export default __webpack_public_path__ + "static/media/Whiskers.147a27c2.jpg";